import { Outlet } from "react-router-dom";
import Flex from "../../../../components/Flex";
// import { PublicNavBar } from "./PatientEmailedIntakeForm";

const PublicLayout = () => {
  return (
    <Flex flexDirection={"column"} height={"100svh"}>
      {/* <PublicNavBar /> */}

      <Flex height={"100%"} width={"100%"}>
        <Outlet />
      </Flex>
    </Flex>
  );
};

export default PublicLayout;
